import React from 'react';
import {graphql, useStaticQuery} from 'gatsby';
import {styled} from 'baseui';
import {GatsbyImage} from 'gatsby-plugin-image';

const Wrapper = styled('div', ({$theme}) => ({
  width: '100%',
  backgroundColor: $theme.colors.white,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: '66px',
}));

const Overlay = styled<'div', {$fullWidth: boolean}>(
  'div',
  ({$theme, $fullWidth}) => ({
    width: 'calc(100% - 32px)',
    borderRadius: '8px',
    margin: '16px',
    padding: '48px 16px',
    maxWidth: $fullWidth ? '1200px' : '1000px',
    backgroundColor: '#f5f5f7',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    [$theme.mediaQuery.small]: {
      flexDirection: 'column',
    },
  })
);

const TextWrapper = styled('div', ({$theme}) => ({
  margin: '16px',
  [$theme.mediaQuery.small]: {
    margin: 0,
  },
}));

const ImageWrapper = styled('div', ({$theme}) => ({
  display: 'flex',
  maxWidth: '500px',
  width: '50%',
  [$theme.mediaQuery.small]: {
    marginTop: '42px',
    width: '100%',
  },
}));

const Title = styled('h3', ({$theme}) => ({
  fontSize: '36px',
  [$theme.mediaQuery.small]: {
    fontSize: '26px',
  },
}));

const Text = styled('p', ({$theme}) => ({
  color: $theme.colors.accent,
  fontSize: '18px',
  margin: '8px 0',
  fontWeight: 700,
  textDecoration: 'none',
  cursor: 'pointer',
  transition: '500ms ease',
  ':hover': {
    textDecoration: 'underline',
  },
  [$theme.mediaQuery.small]: {
    fontSize: '16px',
  },
}));

type Props = {
  fullWidth?: boolean;
};

function ProductSelectGuide({fullWidth}: Props) {
  const data = useStaticQuery(graphql`
    query ProductSelectGuide {
      contentfulHeaderAndFooter {
        productSelectText
        productSelectTitle
        productSelectGuideImage {
          gatsbyImageData
          description
        }
      }
    }
  `);

  const {productSelectText, productSelectTitle, productSelectGuideImage} =
    data.contentfulHeaderAndFooter;

  return (
    <Wrapper>
      <Overlay $fullWidth={Boolean(fullWidth)}>
        <TextWrapper>
          <Title>{productSelectTitle}</Title>
          <Text onClick={() => {}} id='which-orca'>
            {productSelectText}
          </Text>
        </TextWrapper>
        <ImageWrapper>
          <GatsbyImage
            loading='lazy'
            image={productSelectGuideImage.gatsbyImageData}
            style={{width: '100%', height: '100%'}}
            alt={productSelectGuideImage.description}
            imgStyle={{
              objectFit: 'contain',
            }}
          />
        </ImageWrapper>
      </Overlay>
    </Wrapper>
  );
}

export default ProductSelectGuide;
